import type { SVGProps } from 'react';

interface SVGRProps {
  readonly title?: string;
  readonly titleId?: string;
}

const SvgLogoBestBuyWhite = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={26}
    fill="none"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#logo-best-buy-white_svg__a)">
      <path fill="#FFF200" d="M35.21 18.89H44V26h-8.792l-2.187-2.08v-2.935z" />
      <path
        fill="#fff"
        d="m7.889 5.612.17-.062a2 2 0 0 0 .391-.27q.229-.193.458-.443.228-.25.395-.67.165-.418.166-.88 0-1.214-1.084-2.09T5.425.32H0v11.225h5.742c1.472 0 4.521-.277 4.521-3.21 0-2.242-2.323-2.703-2.374-2.723m-4.295-2.66h1.324q.398 0 .65.236a.77.77 0 0 1 .252.584.77.77 0 0 1-.252.585.9.9 0 0 1-.65.237H3.594zm2.473 5.7a1.09 1.09 0 0 1-.78.296H3.593V6.933h1.692q.471 0 .78.29.312.292.311.713 0 .42-.31.717M10.746 18.037l.17-.063q.163-.078.391-.27.23-.192.457-.442.23-.251.396-.67t.166-.88q0-1.215-1.085-2.09-1.085-.877-2.96-.877H2.867v11.224H8.6c1.472 0 4.521-.277 4.521-3.209 0-2.242-2.323-2.703-2.374-2.724m-4.284-2.66h1.314q.397 0 .65.236a.77.77 0 0 1 .252.585.77.77 0 0 1-.252.585q-.252.237-.65.237H6.462zm2.462 5.7a1.09 1.09 0 0 1-.78.296H6.462v-2.015h1.682q.47 0 .78.291t.31.712-.31.717M19.466 8.821h-5.372v-1.76h4.386V4.492h-4.386v-1.44h5.385V.32h-8.98v11.224h8.966zM28.655.321v2.732h2.937v8.492h3.572V3.053h2.937V.32zM24.593 8.641q-.295.26-.818.259-.523 0-1.088-.29-.567-.29-.756-.465l-.188-.178-2.12 2.034.134.136q.194.203.597.485t.934.564 1.325.481 1.638.2q2.108 0 3.356-1.104t1.248-2.661q0-.9-.36-1.581t-.9-1.026a8.4 8.4 0 0 0-1.166-.618 7 7 0 0 0-1.07-.379l-.096-.024a3.5 3.5 0 0 1-.895-.329q-.357-.2-.357-.458a.64.64 0 0 1 .248-.516q.247-.204.705-.204c.726 0 1.17.329 1.399.568l2.127-2.041-.039-.045q-.14-.18-.48-.411a8 8 0 0 0-.794-.466q-.453-.235-1.178-.403A6.7 6.7 0 0 0 24.484 0q-2 0-3.22 1.068t-1.22 2.509q0 .767.27 1.377.272.61.69.971.419.36.934.634.433.229.871.384.084.03.168.058.522.17.945.313.423.145.694.31t.27.391a.8.8 0 0 1-.294.626M19.479 19.416c0 .74-.592 1.343-1.326 1.348a1.34 1.34 0 0 1-1.345-1.348V12.75H13.21v6.496c0 2.68 2.15 4.851 4.803 4.851h.225c2.653 0 4.803-2.172 4.803-4.851V12.75h-3.563zM29.186 16.567 26.83 12.75H23.23l4.16 7.216v4.008h3.594v-4.008l4.16-7.216H31.54zM34.769 22.44c0 .242-.195.439-.435.439a.437.437 0 0 1-.435-.44c0-.242.194-.439.435-.439.24 0 .435.197.435.44M35.098 16.367a.594.594 0 1 1 1.188-.003.59.59 0 0 1-.594.598.586.586 0 0 1-.594-.595m1.11-.003a.505.505 0 0 0-.516-.524.506.506 0 0 0-.514.528c0 .302.227.521.514.521a.51.51 0 0 0 .516-.524m-.714-.321h.2c.134 0 .223.06.223.181v.003c0 .094-.06.146-.145.162l.18.276h-.1l-.17-.262h-.094v.262h-.094zm.2.292q.129 0 .129-.106v-.002c0-.078-.046-.106-.129-.106h-.107v.214z"
      />
    </g>
    <defs>
      <clipPath id="logo-best-buy-white_svg__a">
        <path fill="#fff" d="M0 0h44v26H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgLogoBestBuyWhite;
